/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityProviderSettingsFormConfiguration
 */
export interface IdentityProviderSettingsFormConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    readonly providers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    readonly childProviders?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    cardProviders?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showPhoneNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showAgencyName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showCountryDialingCode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showAddress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showStateProvince?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showOfficeID?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showIATANumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showCity?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showCountry?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showPostalCode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showAllowSalesTicketing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showTicketingSettings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showUseOneAirTicketing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showPaxportChildSupplierSettings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showChannelId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showChannelName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showFLXUserName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showFLXPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showPCC?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showMarketCode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showMarketName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showSaleCity?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showCurrencyCode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showAccountCode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showAgentName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showAgentPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormConfiguration
     */
    showAgentRole?: boolean;
}

export function IdentityProviderSettingsFormConfigurationFromJSON(json: any): IdentityProviderSettingsFormConfiguration {
    return IdentityProviderSettingsFormConfigurationFromJSONTyped(json, false);
}

export function IdentityProviderSettingsFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityProviderSettingsFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'childProviders': !exists(json, 'childProviders') ? undefined : (json['childProviders'] === null ? null : (json['childProviders'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'cardProviders': !exists(json, 'cardProviders') ? undefined : (json['cardProviders'] === null ? null : (json['cardProviders'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'showPhoneNumber': !exists(json, 'showPhoneNumber') ? undefined : json['showPhoneNumber'],
        'showAgencyName': !exists(json, 'showAgencyName') ? undefined : json['showAgencyName'],
        'showCountryDialingCode': !exists(json, 'showCountryDialingCode') ? undefined : json['showCountryDialingCode'],
        'showEmail': !exists(json, 'showEmail') ? undefined : json['showEmail'],
        'showAddress': !exists(json, 'showAddress') ? undefined : json['showAddress'],
        'showStateProvince': !exists(json, 'showStateProvince') ? undefined : json['showStateProvince'],
        'showOfficeID': !exists(json, 'showOfficeID') ? undefined : json['showOfficeID'],
        'showIATANumber': !exists(json, 'showIATANumber') ? undefined : json['showIATANumber'],
        'showCity': !exists(json, 'showCity') ? undefined : json['showCity'],
        'showCountry': !exists(json, 'showCountry') ? undefined : json['showCountry'],
        'showPostalCode': !exists(json, 'showPostalCode') ? undefined : json['showPostalCode'],
        'showAllowSalesTicketing': !exists(json, 'showAllowSalesTicketing') ? undefined : json['showAllowSalesTicketing'],
        'showTicketingSettings': !exists(json, 'showTicketingSettings') ? undefined : json['showTicketingSettings'],
        'showUseOneAirTicketing': !exists(json, 'showUseOneAirTicketing') ? undefined : json['showUseOneAirTicketing'],
        'showPaxportChildSupplierSettings': !exists(json, 'showPaxportChildSupplierSettings') ? undefined : json['showPaxportChildSupplierSettings'],
        'showChannelId': !exists(json, 'showChannelId') ? undefined : json['showChannelId'],
        'showChannelName': !exists(json, 'showChannelName') ? undefined : json['showChannelName'],
        'showFLXUserName': !exists(json, 'showFLXUserName') ? undefined : json['showFLXUserName'],
        'showFLXPassword': !exists(json, 'showFLXPassword') ? undefined : json['showFLXPassword'],
        'showPCC': !exists(json, 'showPCC') ? undefined : json['showPCC'],
        'showMarketCode': !exists(json, 'showMarketCode') ? undefined : json['showMarketCode'],
        'showMarketName': !exists(json, 'showMarketName') ? undefined : json['showMarketName'],
        'showSaleCity': !exists(json, 'showSaleCity') ? undefined : json['showSaleCity'],
        'showCurrencyCode': !exists(json, 'showCurrencyCode') ? undefined : json['showCurrencyCode'],
        'showAccountCode': !exists(json, 'showAccountCode') ? undefined : json['showAccountCode'],
        'showAgentName': !exists(json, 'showAgentName') ? undefined : json['showAgentName'],
        'showAgentPassword': !exists(json, 'showAgentPassword') ? undefined : json['showAgentPassword'],
        'showAgentRole': !exists(json, 'showAgentRole') ? undefined : json['showAgentRole'],
    };
}

export function IdentityProviderSettingsFormConfigurationToJSON(value?: IdentityProviderSettingsFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cardProviders': value.cardProviders === undefined ? undefined : (value.cardProviders === null ? null : (value.cardProviders as Array<any>).map(GuidIdAndLabelToJSON)),
        'showPhoneNumber': value.showPhoneNumber,
        'showAgencyName': value.showAgencyName,
        'showCountryDialingCode': value.showCountryDialingCode,
        'showEmail': value.showEmail,
        'showAddress': value.showAddress,
        'showStateProvince': value.showStateProvince,
        'showOfficeID': value.showOfficeID,
        'showIATANumber': value.showIATANumber,
        'showCity': value.showCity,
        'showCountry': value.showCountry,
        'showPostalCode': value.showPostalCode,
        'showAllowSalesTicketing': value.showAllowSalesTicketing,
        'showTicketingSettings': value.showTicketingSettings,
        'showUseOneAirTicketing': value.showUseOneAirTicketing,
        'showPaxportChildSupplierSettings': value.showPaxportChildSupplierSettings,
        'showChannelId': value.showChannelId,
        'showChannelName': value.showChannelName,
        'showFLXUserName': value.showFLXUserName,
        'showFLXPassword': value.showFLXPassword,
        'showPCC': value.showPCC,
        'showMarketCode': value.showMarketCode,
        'showMarketName': value.showMarketName,
        'showSaleCity': value.showSaleCity,
        'showCurrencyCode': value.showCurrencyCode,
        'showAccountCode': value.showAccountCode,
        'showAgentName': value.showAgentName,
        'showAgentPassword': value.showAgentPassword,
        'showAgentRole': value.showAgentRole,
    };
}


